import { AlertCircle, Maximize2, Minimize2 } from 'lucide-react';
import { useState } from 'react';

import { useDemo } from '../contexts/DemoContext';

import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';

export function TagAssistantModal() {
  const [isMinimized, setIsMinimized] = useState(false);

  const { navigationHistory } = useDemo();

  function handleToggleMinimized() {
    setIsMinimized((value) => !value);
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 w-96 overflow-hidden rounded-lg border border-border bg-background shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between bg-primary px-4 py-3 text-primary-foreground">
        <div className="flex items-center gap-2">
          <svg
            className="h-5 w-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
          <h3 className="text-sm font-medium">Tag Assistant</h3>
          <Badge
            variant="secondary"
            className="border-0 bg-primary-foreground/20 text-primary-foreground"
          >
            {navigationHistory.length}
          </Badge>
        </div>

        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7 text-primary-foreground hover:bg-primary-foreground/20"
            onClick={handleToggleMinimized}
          >
            {isMinimized ? (
              <Maximize2 className="h-4 w-4" />
            ) : (
              <Minimize2 className="h-4 w-4" />
            )}
          </Button>
        </div>
      </div>

      {/* Content */}
      {!isMinimized && (
        <div className="max-h-96 overflow-y-auto bg-background">
          {navigationHistory.length === 0 ? (
            <div className="p-8 text-center text-muted-foreground">
              <AlertCircle className="mx-auto mb-2 h-8 w-8 opacity-50" />
              <p className="text-sm">Nenhum evento detectado</p>
              <p className="mt-1 text-xs">
                Navegue pelo site para ver os eventos
              </p>
            </div>
          ) : (
            <div className="divide-y divide-border">
              {navigationHistory.map((event, index) => (
                <div key={index} className="ml-6">
                  <pre className="overflow-x-auto rounded bg-muted/50 p-2 text-xs text-muted-foreground">
                    {event}
                  </pre>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
